import React, { useContext, useEffect, useState } from "react";
import { Button, Form, H3, H4, Span } from "../../Styles/Global.Styled";
import { css } from "styled-components";
import { getFormComponent, processFormData } from "../../helpers/formHandlers";
import { confirmVerifyCode, requestVerifyCode } from "../../api/auth";
import { verificationCodeProps } from "../../helpers/formProps";
import { AuthContext } from "../../Context/AuthContext";
import FormSubmissionBttn from "../../Components/Buttons/FormSubmissionBttn";
import SendIcon from "../../Icons/SendIcon";

const formStyle = css`
  padding: 0 4vh 3vh;
  gap: 2.5vh;
  align-items: center;
  /* border:2px solid red; */
`;

const h3Style = css`
  font-size: 2.5vh;
  font-weight: 400;
  align-self: center;
`;

const h4Style = css`
  font-size: 1.25vh;
  font-weight: 200;
  margin-bottom: -0.5vh;
  /* font-family: "Poppins"; */
  display: inline;
  width: 35vh;
  /* border:2px solid red; */
`;

const emailStyle = css`
  font-size: 1.25vh;
  font-size: 400;
  font-style: italic;
  text-decoration: underline;
  margin-left: 0.5vh;
  display: inline;
`;

const reqCodeButton = css`
  text-decoration: underline;
`;

const VerifyCodeForm = ({ actionForm, credentials, showToast }) => {
  const [formData, setForm] = useState([verificationCodeProps()]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [remainingTime, setRemainingTime] = useState(60);
  const { login } = useContext(AuthContext);

  // Countdown timer for disabling the submit button
  useEffect(() => {
    if (remainingTime > 0) {
      const timer = setTimeout(() => {
        setRemainingTime((prev) => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      setIsDisabled(false);
    }
  }, [remainingTime]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setIsDisabled(true);
    setRemainingTime(60); // Start the cooldown timer (60 seconds)

    try {
      const processedData = processFormData(formData);
      if (processedData.errors === true) {
        const firstError = processedData.formErrors[0];
        showToast({
          title: `Input error`,
          text: `${firstError.errors}`,
          type: "Error",
        });
        return;
      }
      processedData.email = credentials[0];
      processedData.password = credentials[1];

      await confirmVerifyCode(processedData);
      showToast({
        title: "Success",
        text: "You are now logged in.",
        type: "Success",
      });

      login();
      actionForm();
    } catch (error) {
      showToast({
        title: "Unexpected error",
        text: error.message,
        type: "Error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCodeRequest = async (email) => {
    try {
      await requestVerifyCode({ email });
      setIsDisabled(true);
      setRemainingTime(60); // Start the cooldown timer (60 seconds)
      showToast({
        title: "Success",
        text: "You are now logged in.",
        type: "Success",
      });
    } catch (error) {
      showToast({
        title: "Unexpected error",
        text: error.message,
        type: "Error",
      });
    }
  };

  return (
    <Form $baseStyle={formStyle} onSubmit={(e) => handleSubmit(e)}>
      <H3 $baseStyle={h3Style}>Verify Your Email</H3>
      <H4 $baseStyle={h4Style}>
        Please enter the verification code sent to
        <Span $baseStyle={emailStyle}>{credentials[0]}</Span>, you can request a
        new code {remainingTime > 0 ? `in ${remainingTime} seconds` : "now"}.
      </H4>
      {getFormComponent({ props: formData[0], setForm, index: 0 })}
      <FormSubmissionBttn text="Submit" icon={<SendIcon/>} isLoading={isLoading}/>
      <Button
        type="button"
        $baseStyle={reqCodeButton}
        disabled={isDisabled}
        onClick={() => handleCodeRequest(credentials[0])}
      >
        Request a new code
      </Button>
    </Form>
  );
};

export default VerifyCodeForm;
